<template>
  <svg width="31" height="34" viewBox="0 0 31 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.618332 0.516263C0.226665 0.916014 0 1.53839 0 2.34439V31.0939C0 31.8999 0.226665 32.5223 0.618332 32.922L0.714999 33.0098L17.2383 16.906V16.5258L0.714999 0.422016L0.618332 0.516263Z" fill="url(#paint0_linear_9941_23943)" />
    <path d="M22.7399 22.2773L17.2383 16.9067V16.5265L22.7466 11.1558L22.8699 11.2257L29.3933 14.8446C31.2549 15.8716 31.2549 17.5616 29.3933 18.5951L22.8699 22.2075L22.7399 22.2773Z" fill="url(#paint1_linear_9941_23943)" />
    <path d="M22.8708 22.207L17.2391 16.7162L0.619141 32.9223C1.23747 33.556 2.24581 33.6324 3.39247 32.9987L22.8708 22.207Z" fill="url(#paint2_linear_9941_23943)" />
    <path d="M22.8708 11.2249L3.39247 0.433325C2.24581 -0.193926 1.23747 -0.117552 0.619141 0.516197L17.2391 16.7158L22.8708 11.2249Z" fill="url(#paint3_linear_9941_23943)" />
    <defs>
      <linearGradient id="paint0_linear_9941_23943" x1="15.7713" y1="31.3933" x2="-6.03887" y2="9.02393" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00A0FF" />
        <stop offset="0.0066" stop-color="#00A1FF" />
        <stop offset="0.2601" stop-color="#00BEFF" />
        <stop offset="0.5122" stop-color="#00D2FF" />
        <stop offset="0.7604" stop-color="#00DFFF" />
        <stop offset="1" stop-color="#00E3FF" />
      </linearGradient>
      <linearGradient id="paint1_linear_9941_23943" x1="31.8175" y1="16.7148" x2="-0.445048" y2="16.7148" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFE000" />
        <stop offset="0.4087" stop-color="#FFBD00" />
        <stop offset="0.7754" stop-color="#FFA500" />
        <stop offset="1" stop-color="#FF9C00" />
      </linearGradient>
      <linearGradient id="paint2_linear_9941_23943" x1="19.8085" y1="13.7312" x2="-9.76784" y2="-16.6034" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF3A44" />
        <stop offset="1" stop-color="#C31162" />
      </linearGradient>
      <linearGradient id="paint3_linear_9941_23943" x1="-3.56446" y1="42.4868" x2="9.64269" y2="28.9411" gradientUnits="userSpaceOnUse">
        <stop stop-color="#32A071" />
        <stop offset="0.0685" stop-color="#2DA771" />
        <stop offset="0.4762" stop-color="#15CF74" />
        <stop offset="0.8009" stop-color="#06E775" />
        <stop offset="1" stop-color="#00F076" />
      </linearGradient>
    </defs>
  </svg>
</template>
